import React, {useEffect, useRef, useState} from "react";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions/CardActions";
import Button from "@material-ui/core/Button";
import {ApolloMessage} from "../../../atom/Apollo_Mesasge";
import {
    apollo_useStyles,
    options_age,
    options_area_pref,
    options_ms_bid_ctgry,
    options_ms_campaign_type,
    options_select_ms_campaign_type,
    options_state_edit_ms
} from "../../../atom/Apollo_styles";
import {APOLLO_GROUP_OPERATOR, APOLLO_SYSTEM_ADMIN, ApolloUserProfileAuth} from "../../../atom/Apollo_Authorization";
import {useForm} from "react-hook-form";
import {useHistory} from "react-router-dom";
import {ApolloContext} from "../../../atom/Apollo_Context";
import {AdGroup, AdGroupCreate, AdGroupUpdate, AdGroupOsType, TargetInfo} from "./common/AdGroupModel";
import {AdProcessType, BLANK} from "../../ADVERTISEMENT/ms/common/CommonConst";
import {
    adgroupsms_path,
    apollo_account_path,
    get_ms_adgroup_path,
    get_ms_advertisements_path,
    get_ms_campaign_path,
    get_ms_campaigns_path,
    hera_account_path,
    hera_audiences_path,
    list_poseidon_availableaffinity_path,
    list_poseidon_availablegeosegments_path,
    list_poseidon_availabletarget_path,
    post_ms_adgroup_path,
    put_ms_adgroup_path
} from "../../../atom/Apollo_links";
import {MeasureCondition} from "../../CAMPAIGN/CampaignModel";
import {
    ApolloBasicCheck,
    ApolloBasicRadio,
    ApolloBasicSelect,
    ApolloBasicTextField
} from "../../../molecule/Apollo_BaseItem";
import {ARCHIVE_VALUE_NO, CAMPAIGN_TYPE, RESULT_KBN} from "../../CAMPAIGN/ms/common/CommonConst";
import Typography from "@material-ui/core/Typography";
import {Divider, TextField} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Collapse from "@material-ui/core/Collapse/Collapse";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import {cloneDeep, toString} from "lodash";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import {
    AD_TYPE,
    AdGroupProcessType,
    BID_CTRY,
    CHARGE_TYPE_TO_BID_CTGRY_TRANSFER_MAP,
    INIT_NUMBER,
    INIT_STR,
    MSG,
    options_ms_ad_target,
    options_ms_ad_type_jp,
    options_ms_os_type,
    RESULT_ACCOUNT_ERROR,
    TARGET_TYPE,
    AFFINITY_CATEGORY_MAX_MS
} from "./common/CommonConst";
import {Campaign} from "../../CAMPAIGN/ms/common/CommonModel";
import {
    checkInvalidTabCharsForName,
    getAccountsDeletedAudience,
    getTrackerAudience,
    getTrackingArrayItems,
    getTrackingMacroLength,
    joinTrackingValue,
    TrackingItem,
    TrackingPointItem,
    transferTargetInfo
} from "../../../common/Apollo_CommonUtil";
import {ApolloAxios, getResultType} from "../../../atom/Apollo_ApiRequest3";
import Modal from "@material-ui/core/Modal";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {
    ApolloEventRecord,
    createLogDate,
    createUserLogItemListFromRadioValues,
    createUserLogItemListFromNumber,
    createUserLogItemListFromOptionValue,
    createUserLogItemListFromString,
    ItemList,
    LogData,
    createUserLogItemListFromSugotokuMs,
    createUserLogItemListFromAgeMs,
    createUserLogItemListFromPrefectureMs,
    createUserLogItemListFromGenderMs,
    createUserLogItemListFromOptionValuesNormalListMs,
    createUserLogItemListFromOptionValuesAfinitysMs,
} from "../../../atom/Apollo_EventRecord";
import {Bars} from "react-loader-spinner";
import {Backdrop} from "@material-ui/core";
import moment from "moment";
import {ApolloDialog} from "../../../atom/Apollo_Dialog";
import {ApolloConfirmNotActiveDialog} from "../../../organism/HERA/ConfirmNotActiveDialog";

type LogRecord = {
    data: AdGroup,
    prefecture: number[]
}

type AdGroupEditProps = {
    accountGrpId: number;
    accountId: number;
    platformaccountid: number;
    campaignId: number;
    adGroupId: number | null;
    processType: string;
    listReloadFunc?: any;
}

type Audience = {
    ID: number;
    name: string;
    isActive: boolean;
    condition: MeasureCondition;
    audienceSpan: number;
}

type Geosegment = {
    id: number;
    name: string;
    geoPoints: GeoPoint[];
}

type GeoPoint = {
    geoPointId: number;
}

type Custom = {
    id: number;
    name: string;
}

type Affinity = {
    id: number;
    name: string;
}

type CampaignForOption = {
    campaignType: number;
    id: number;
    name: string;
    bidCtgry: number;
}

type AdTrackingParam = {
    trackingParam: string;
}

const apollo_AdStyles = makeStyles({
    previewModalMs: {
        overflow: "auto",
        height: "90%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    assetListModalMs: {
        top: "40%",
        left: "50%",
        transform: "translate(-40%, -50%)",
    },
});

export const initTargetInfo: TargetInfo = {
    targetType: 1,
    targetId: INIT_NUMBER,
    targetIdfForCustom: INIT_NUMBER,
    targetIdForRetage: INIT_NUMBER,
    gender: [],
    age: [null, null],
    prefecture: [],
    sugotoku: [0],
    category: [],
    geopointid: [],
}

export const initAdGroup: AdGroup = {

    campaignId: INIT_NUMBER,
    campaignName: INIT_STR,
    campaignType: 1,
    campaignStatus: INIT_NUMBER,
    adGroupId: INIT_NUMBER,
    adGroupName: INIT_STR,
    adGroupStatus: 3,
    displayParentArchive: INIT_NUMBER,
    osType: 1,
    bidCtgry: INIT_NUMBER,
    cpcLimit: 0,
    targetInfo: initTargetInfo,
    distributionScd: INIT_STR,
    adType: 1,
    trackingParam: INIT_STR,
    targetChangeable: 1,
    trackingParamChangeable: 1,
    createdDatetime: INIT_STR,
    updatedDatetime: INIT_STR,
    lastUpdatedUserId: INIT_STR,
    lastUpdatedVer: INIT_STR,
}

const createOsTypeValue = (osType: AdGroupOsType): number => {
    if (osType.android && osType.ios) {
        return options_ms_os_type[0].value
    }
    if (osType.android) {
        return options_ms_os_type[1].value
    }
    if (osType.ios) {
        return options_ms_os_type[2].value
    }
    return 0;
}

const createOsTypeDisplay = (osType: number): AdGroupOsType => {
    let result: AdGroupOsType = {
        android: false,
        ios: false,
    }
    switch (osType) {
        case options_ms_os_type[0].value:
            result.android = true;
            result.ios = true;
            break;
        case options_ms_os_type[1].value:
            result.android = true;
            break;
        case options_ms_os_type[2].value:
            result.ios = true;
            break;
    }
    return result
}

/*
    画面名：広告グループ編集（MS）
 */
const AdGroupEditMs: React.FC<AdGroupEditProps> = ({
                                                       accountGrpId,
                                                       accountId,
                                                       platformaccountid,
                                                       campaignId,
                                                       adGroupId,
                                                       processType,
                                                       listReloadFunc,
                                                   }) => {

    // style
    const classes = apollo_useStyles();
    const adClasses = apollo_AdStyles();

    // history
    const history = useHistory();

    // useContext
    const {state: apolloContex} = React.useContext(ApolloContext);
    const {data: msg, setmsg} = React.useContext(ApolloMessage);

    // form
    const {
        register,
        handleSubmit,
        control,
        errors,
        formState,
        clearErrors,
        setValue,
        getValues,
        setError
    } = useForm({reValidateMode: 'onBlur'});

    // useState
    const [adGroup, setAdGroup] = useState<AdGroup>(initAdGroup)

    const [campaignType, setCampaignType] = useState<number>(0)

    const [trackingItems, setTrackingItems] = useState<TrackingItem[]>([])

    const [checkedPref, setCheckedPref] = useState([false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,]);

    const [prefRenderId, setPrefRenderId] = useState(0);

    const [enableSugotoku, setEnableSugotoku] = useState(true);

    const [heraAudiences, setHeraAudiences] = useState<Audience[]>([])
    const [tmpAudiences, setTmpAudiences] = useState<Audience[]>([])
    const [tmpDeletedAudiences, setTmpDeletedAudiences] = useState<Audience[]>([])
    const [poseidonCustoms, setPoseidonCustoms] = useState<Custom[]>([])
    const [poseidonAffinities, setPoseidonAffinities] = useState<Affinity[]>([])
    const [campaignList, setCampaignList] = useState<CampaignForOption[]>([])
    const [adTrackingParams, setAdTrackingParams] = useState<AdTrackingParam[]>([])
    const [geosegments, setGeosegments] = useState<Geosegment[]>([])
    const [openTrackingAlert, setOpenTrackingAlert] = React.useState(false)

    const [osType, setOsType] = useState<AdGroupOsType>({
        android: true,
        ios: true,
    })

    const [progress, setProgress] = useState(true);

    const isExistsNotActiveAudience = useRef<boolean>(false)
    const isExistsDeletedAudience = useRef<boolean>(false)
    const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false)

    // useRef
    const trackingItemMaxNo = useRef(0)
    const isOkTrackingAlert = useRef(false)
    const beforeEditRecord = useRef<LogRecord | null>(null);
    const processing = useRef(false);

    // etc
    const trackerId = apolloContex.current.trackerId

    const options_audience = heraAudiences?.map(audience => ({value: audience.ID, label: `${audience.ID}_${audience.name}`}))
    const options_custom = poseidonCustoms?.map(custom => ({value: custom.id, label: `${custom.id}_${custom.name}`}))
    const options_affinity = poseidonAffinities?.map(affinity => ({value: affinity.id, label: `${affinity.id}_${affinity.name}`}))
    const options_geosegment = geosegments?.map(geosegment => ({value: geosegment.id, label: `${geosegment.id}_${geosegment.name}`}))

    const targetRadioOptions =
        adGroup.campaignType === CAMPAIGN_TYPE.MS ?
            adGroup.bidCtgry !== BID_CTRY.Manual_CPM ? [
                {label: options_ms_ad_target[0].label, value: options_ms_ad_target[0].value},
                {label: options_ms_ad_target[1].label, value: options_ms_ad_target[1].value},
                {label: options_ms_ad_target[2].label, value: options_ms_ad_target[2].value},
                {label: options_ms_ad_target[3].label, value: options_ms_ad_target[3].value},
            ] : [
                {label: options_ms_ad_target[0].label, value: options_ms_ad_target[0].value},
                {label: options_ms_ad_target[1].label, value: options_ms_ad_target[1].value},
                {label: options_ms_ad_target[2].label, value: options_ms_ad_target[2].value},
            ] :
            adGroup.campaignType === CAMPAIGN_TYPE.RTM ?
                [
                    {label: options_ms_ad_target[4].label, value: options_ms_ad_target[4].value},
                    {label: options_ms_ad_target[5].label, value: options_ms_ad_target[5].value},
                ]
                : []

    const options_campaignNames =
        campaignList?.filter(campaignName => campaignName.campaignType === adGroup.campaignType).map(campaignName => ({
            value: campaignName.id,
            label: `${campaignName.id}_${campaignName.name}`,
        }))

    const disableTargeting = adGroup.targetChangeable === 0
    const disableTrackingParam = adGroup.trackingParamChangeable === 0

    // function
    const onAddTrackingItem = ((event: any) => {
        trackingItemMaxNo.current++
        setTrackingItems([...trackingItems, {id: trackingItemMaxNo.current, key: BLANK, value: BLANK}])
    });

    const goBack = (campaignIdLocal: number) => {
        const queryParams = campaignIdLocal !== 0 ? `?campaignId=${campaignIdLocal}` : "";
        processType === AdGroupProcessType.create ?
            history.push(`${adgroupsms_path}${accountGrpId}/${accountId}/${platformaccountid}${queryParams}`) :
            listReloadFunc && listReloadFunc()
    };

    const trackingAlertContinueButtonClick = () => {
        setOpenTrackingAlert(false);
        isOkTrackingAlert.current = true;
        onSubmit()
    };

    const trackingAlertCloseButtonClick = () => {
        setOpenTrackingAlert(false);
    };

    const handleOpenConfirm = () => {
        if (!openConfirmDialog) setOpenConfirmDialog(true)
    }

    const handleCloseConfirm = () => {
        if (openConfirmDialog) setOpenConfirmDialog(false)
    }

    const onSubmit = handleSubmit(async (formData: any) => {

        const prefecture = checkedPref.map((value, index) => {
            return value ? index + 1 : 0
        }).filter(value => value !== 0)

        if ((adGroup.targetInfo.targetType === TARGET_TYPE.DEMOGRA || adGroup.targetInfo.targetType === TARGET_TYPE.GEOTARGET_DEMOGRA) && (adGroup.targetInfo.sugotoku[0] === 0 || adGroup.campaignType === CAMPAIGN_TYPE.RTM)) {

            if ((adGroup.targetInfo.age[0] === null && adGroup.targetInfo.age[1] !== null)
                || (adGroup.targetInfo.age[0] !== null && adGroup.targetInfo.age[1] === null)) {
                setmsg({
                    type: "setMessage",
                    payload: {
                        ...msg,
                        open: true,
                        type: "error",
                        message: "ターゲティング情報の年齢は、両方入力してください。"
                    }
                });
                return
            } else if (adGroup.targetInfo.age[0] != null && adGroup.targetInfo.age[1] != null && adGroup.targetInfo.age[0] > adGroup.targetInfo.age[1]) {
                setmsg({
                    type: "setMessage",
                    payload: {
                        ...msg,
                        open: true,
                        type: "error",
                        message: "ターゲティング情報の年齢は、下限を上限以下の年齢で入力してください。"
                    }
                });
                return
            }

            if (adGroup.targetInfo.gender.length === 0
                && (adGroup.targetInfo.age[0] === null && adGroup.targetInfo.age[1] === null)
                && prefecture.length === 0
                && (adGroup.targetInfo.targetType === TARGET_TYPE.GEOTARGET_DEMOGRA || (adGroup.targetInfo.targetType === TARGET_TYPE.DEMOGRA && adGroup.targetInfo.category.length === 0))
            ) {
                setmsg({
                    type: "setMessage",
                    payload: {
                        ...msg,
                        open: true,
                        type: "error",
                        message: "ターゲティング情報の性別、年齢、居住地" + (adGroup.targetInfo.targetType === TARGET_TYPE.DEMOGRA ? "、アフィニティカテゴリ" : "") + "が入力されていません。"
                    }
                });
                return
            }
        }

        if (adGroup.cpcLimit !== null) {

            if (adGroup.campaignType === CAMPAIGN_TYPE.MS && adGroup.adType === AD_TYPE.MAIL) {

                if (adGroup.bidCtgry === BID_CTRY.Max_CPC && adGroup.cpcLimit < 20) {
                    setError("cpcLimit", {type: "manual", message: "20円以上を入力してください。"});
                    return
                }

                if (adGroup.bidCtgry === BID_CTRY.Manual_CPM && adGroup.cpcLimit < 700) {
                    setError("cpcLimit", {type: "manual", message: "700円以上を入力してください。"});
                    return
                }
            }

            if (adGroup.campaignType === CAMPAIGN_TYPE.RTM && adGroup.adType === AD_TYPE.MAIL) {

                if (adGroup.bidCtgry === BID_CTRY.Manual_CPM && adGroup.cpcLimit < 3000) {
                    setError("cpcLimit", {type: "manual", message: "3000円以上を入力してください。"});
                    return
                }
            }
        }

        const trackingParams = joinTrackingValue(trackingItems);

        if (!osType.ios && !osType.android) {
            setmsg({
                type: "setMessage",
                payload: {
                    ...msg,
                    open: true,
                    type: "error",
                    message: "配信OSを選択してください。"
                }
            });
            return
        }

        if (getTrackingMacroLength(trackingItems) > 1200) {
            setmsg({
                type: "setMessage",
                payload: {
                    ...msg,
                    open: true,
                    type: "error",
                    message: "トラッキングパラメータの値が1200バイトを超えています。"
                }
            });
            return
        }

        if ((!isOkTrackingAlert.current &&
            adTrackingParams?.filter(e => e.trackingParam !== BLANK).length > 0
        ) && (
            !(trackingParams === BLANK && adGroup.trackingParam === BLANK) && trackingParams != adGroup.trackingParam
        )) {
            setOpenTrackingAlert(true);
            return;
        }

        if (adGroup.targetInfo.targetType === TARGET_TYPE.RETAGE) {
            isExistsNotActiveAudience.current = false;
            isExistsDeletedAudience.current = false;
        
            if (trackerId) {
                const localValAudience = await getTrackerAudience(trackerId);
                if (localValAudience.message !== "") {
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...msg,
                            open: true,
                            type: "error",
                            message: localValAudience.message
                        }
                    });
                    return
                }
                if (localValAudience.result) {
                    const val = localValAudience?.result?.find(v => v.ID === adGroup.targetInfo.targetIdForRetage)
                    if (val?.isActive === false) {
                        isExistsNotActiveAudience.current = true;
                    }
                }
            }

            if (processType !== AdGroupProcessType.create) {
                const localValDeletedAudience = await getAccountsDeletedAudience(apolloContex.current.accountId);
                if (localValDeletedAudience.message !== "") {
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...msg,
                            open: true,
                            type: "error",
                            message: localValDeletedAudience.message
                        }
                    });
                    return
                }
                if (localValDeletedAudience.result) {
                    const val = localValDeletedAudience?.result?.find(v => v.ID === adGroup.targetInfo.targetIdForRetage)
                    if (val) {
                        isExistsDeletedAudience.current = true;
                    }
                }
            }

            if (isExistsNotActiveAudience.current || isExistsDeletedAudience.current) {
                handleOpenConfirm()
                return;
            }
        }

        await handleSubmitExecute();
    })

    const handleSubmitExecute = async() => {

        let isSuccess = false;
        if (formState.isSubmitting) return;
        if (processing.current) return;
        processing.current = true

        const prefecture = checkedPref.map((value, index) => {
            return value ? index + 1 : 0
        }).filter(value => value !== 0)
        const osTypeValue = createOsTypeValue(osType)
        const trackingParams = joinTrackingValue(trackingItems);
        const targetInfo = transferTargetInfo(adGroup.targetInfo, prefecture)

        const editLogInfo = createUserLog(
            apolloContex,
            "メール広告",
            "広告グループ",
            processType,
            processType === AdProcessType.create ? "広告グループ（MS）作成" : "広告グループ（MS）編集",
            beforeEditRecord.current,
            {
                data: {
                    ...cloneDeep(adGroup),
                    osType: osTypeValue,
                    trackingParam: trackingParams,
                },
                prefecture: prefecture
            },
            {
                status: options_state_edit_ms,
                campaignType: options_ms_campaign_type,
                category: options_affinity,
                custom: options_custom,
                retage: options_audience,
                geosegment: options_geosegment,
            },
            String(adGroup.campaignId),
            adGroup.campaignName,
            String(adGroup.adGroupId || BLANK),
            adGroup.adGroupName,
        )
        ApolloEventRecord({...editLogInfo, logType: "execute"})

        if (processType === AdGroupProcessType.create) {

            const url = `${process.env.REACT_APP_API_ENDPOINT}${post_ms_adgroup_path}`
            const adGroupCreate: AdGroupCreate = {
                adAccountId: platformaccountid,
                campaignId: adGroup.campaignId,
                adGroupName: adGroup.adGroupName,
                adGroupStatus: adGroup.adGroupStatus,
                osType: osTypeValue,
                bidCtgry: adGroup.bidCtgry,
                cpcLimit: Number(adGroup.cpcLimit),
                targetInfo: targetInfo,
                adType: adGroup.adType,
                trackingParam: trackingParams,
                userId: toString(apolloContex.userprofile.userId),
            }

            let registedId = BLANK

            await ApolloAxios.post(
                url,
                adGroupCreate,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apolloContex.accesstoken}`,
                    }
                })
                .then((response) => {
                    if (response.data.resultcode == RESULT_KBN.SUCCESS) {
                        isSuccess = true;
                        registedId = response.data.registedId?.toString() ?? BLANK
                        setmsg({
                            type: "setMessage",
                            payload: {
                                ...msg,
                                open: true,
                                type: "success",
                                message: MSG.SUCCESS_POST_AD_GROUP
                            }
                        });
                    } else {
                        setmsg({
                            type: "setMessage",
                            payload: {
                                ...msg,
                                open: true,
                                type: "error",
                                message: `${MSG.ERR_POST_ADGROUP}${response?.data?.message ?? BLANK}`
                            }
                        });
                    }
                })
                .catch((err) => {
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...msg,
                            open: true,
                            type: "error",
                            message: `${MSG.ERR_POST_ADGROUP}${err?.errmsg ?? BLANK}`
                        }
                    });
                }).finally(() => {
                    processing.current = false;
                    const eventRecords: LogData = {
                        ...editLogInfo,
                        eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
                        targetID: registedId,
                        targetName: adGroup.adGroupName,
                        logType: "result",
                        result: isSuccess ? "成功" : "失敗",
                        adGroupID: registedId,
                    }
                    ApolloEventRecord(eventRecords)
                    goBack(campaignId);
                });
        } else {

            if (adGroup.campaignType == CAMPAIGN_TYPE.RTM) {
                processing.current = false;
                setmsg({
                    type: "setMessage",
                    payload: {
                        ...msg,
                        open: true,
                        type: "error",
                        message: `${"リアルタイムメッセージSのキャンペーンに紐づく広告グループは変更できません。"}`,
                    }
                });
                return;
            }

            const url = `${process.env.REACT_APP_API_ENDPOINT}${put_ms_adgroup_path}`
            const adGroupUpdate: AdGroupUpdate = {
                adAccountId: platformaccountid,
                adGroupId: adGroup.adGroupId,
                adGroupName: adGroup.adGroupName,
                adGroupStatus: adGroup.adGroupStatus,
                osType: osTypeValue,
                cpcLimit: Number(adGroup.cpcLimit),
                targetInfo: targetInfo,
                trackingParam: trackingParams,
                userId: toString(apolloContex.userprofile.userId),
                lastUpdatedVer: adGroup.lastUpdatedVer
            }

            await ApolloAxios.put(
                url,
                adGroupUpdate,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apolloContex.accesstoken}`,
                    }
                })
                .then((response) => {
                    if (response.data.resultcode == RESULT_KBN.SUCCESS) {
                        isSuccess = true;
                        setmsg({
                            type: "setMessage",
                            payload: {
                                ...msg,
                                open: true,
                                type: "success",
                                message: MSG.SUCCESS_PUT_AD_GROUP
                            }
                        });
                    } else {
                        setmsg({
                            type: "setMessage",
                            payload: {
                                ...msg,
                                open: true,
                                type: "error",
                                message: `${MSG.ERR_PUT_ADGROUP}${response?.data?.message ?? BLANK}`
                            }
                        });
                    }
                })
                .catch((err) => {
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...msg,
                            open: true,
                            type: "error",
                            message: `${MSG.ERR_PUT_ADGROUP}${err?.errmsg ?? BLANK}`
                        }
                    });
                }).finally(() => {
                    processing.current = false;
                    const eventRecords: LogData = {
                        ...editLogInfo,
                        eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
                        targetID: adGroup.adGroupId.toString(),
                        targetName: adGroup.adGroupName,
                        logType: "result",
                        result: isSuccess ? "成功" : "失敗"
                    }
                    ApolloEventRecord(eventRecords)
                    goBack(campaignId);
                });
        }
    }

    useEffect(() => {

        // トラッカーIDが無い場合
        if (!trackerId) {
            setmsg({
                type: "setMessage",
                payload: {
                    ...msg,
                    open: true,
                    type: "error",
                    message: MSG.ERR_TRACKER_ID
                }
            });
            setProgress(false)
            return
        }

        //キャンペーン情報取得
        const fetchMsCampaign = async () => {
            const url = `${process.env.REACT_APP_API_ENDPOINT}${get_ms_campaign_path}/${platformaccountid}/${campaignId}`
            await ApolloAxios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${apolloContex.accesstoken}`,
                }
            })
                .then((response) => {
                    if (response.data.resultcode === RESULT_KBN.SUCCESS) {
                        const resultData: Campaign = response.data.result
                        if (processType === AdGroupProcessType.create) {
                            const bidCtgry = resultData.billingType && CHARGE_TYPE_TO_BID_CTGRY_TRANSFER_MAP.has(resultData.billingType) ?
                                CHARGE_TYPE_TO_BID_CTGRY_TRANSFER_MAP.get(resultData.billingType) ?? INIT_NUMBER
                                : INIT_NUMBER
                            setAdGroup(prev => ({
                                ...prev,
                                campaignType: resultData.campaignType,
                                campaignName: resultData.name,
                                campaignId: resultData.id,
                                bidCtgry: bidCtgry,
                            }))
                        }
                        setCampaignType(resultData.campaignType)
                    } else if (response.data.resultcode === RESULT_KBN.ERROR) {
                        setmsg({
                            type: "setMessage",
                            payload: {
                                ...msg,
                                open: true,
                                type: "error",
                                message: `${MSG.ERR_GET_CAMPAIGN}${response?.data?.message ?? BLANK}`
                            }
                        });
                    }
                })
                .catch((err) => {
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...msg,
                            open: true,
                            type: "error",
                            message: `${MSG.ERR_GET_CAMPAIGN}${err?.errmsg ?? BLANK}`
                        }
                    });
                })
        }

        const fetchMsCampaignList = async () => {
            const url = `${process.env.REACT_APP_API_ENDPOINT}${get_ms_campaigns_path}/${platformaccountid}`;
            await ApolloAxios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${apolloContex.accesstoken}`,
                }
            })
                .then((response) => {
                    if (response.data.resultcode === RESULT_KBN.SUCCESS) {
                        if (response.data.result?.length > 0) {
                            const campaignList = response.data ?
                                response.data.result.map((elem: any) => {
                                    const bidCtgry = elem.billingType && CHARGE_TYPE_TO_BID_CTGRY_TRANSFER_MAP.has(elem.billingType) ?
                                        CHARGE_TYPE_TO_BID_CTGRY_TRANSFER_MAP.get(elem.billingType) ?? INIT_NUMBER
                                        : INIT_NUMBER
                                    return {
                                        id: elem.id,
                                        name: elem.name,
                                        campaignType: elem.campaignType,
                                        bidCtgry: bidCtgry,
                                    }
                                }) : []
                            setCampaignList(campaignList)
                        }
                    } else if (response.data.resultcode === RESULT_KBN.ERROR) {
                        setmsg({
                            type: "setMessage",
                            payload: {
                                ...msg,
                                open: true,
                                type: "error",
                                message: `${MSG.ERR_GET_CAMPAIGN}${response?.data?.message ?? BLANK}`
                            }
                        });
                    }
                })
                .catch((err) => {
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...msg,
                            open: true,
                            type: "error",
                            message: `${MSG.ERR_GET_CAMPAIGN}${err?.errmsg ?? BLANK}`
                        }
                    });
                })
        }

        const fetchAccount = async () => {
            const urlAccount = `${process.env.REACT_APP_API_ENDPOINT}${apollo_account_path}/${accountGrpId}/${accountId}`
            ApolloAxios.get(urlAccount,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apolloContex.accesstoken}`,
                    },
                })
                .then((response) => {
                    if (response.data?.resultCode === RESULT_ACCOUNT_ERROR) {
                        setmsg({
                            type: "setMessage",
                            payload: {
                                ...msg,
                                open: true,
                                type: "error",
                                message: `${MSG.ERR_GET_ACCOUNT}${response?.data?.message ?? BLANK}`
                            }
                        });
                    } else {
                        setEnableSugotoku(response.data.result["targetingFlg"] === 1);
                    }
                }).catch((err) => {
                setmsg({
                    type: "setMessage",
                    payload: {
                        ...msg,
                        open: true,
                        type: "error",
                        message: `${MSG.ERR_GET_ACCOUNT}${err?.errmsg ?? BLANK}`
                    }
                });
            })
        }

        const fetchMsAdGroup = async () => {
            const url = `${process.env.REACT_APP_API_ENDPOINT}${get_ms_adgroup_path}/${platformaccountid}/${campaignId}/${adGroupId}`
            await ApolloAxios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${apolloContex.accesstoken}`,
                }
            })
                .then((response) => {
                    if (response.data.resultcode === RESULT_KBN.SUCCESS) {
                        const resultData: AdGroup = response.data.result
                        const targetType = resultData.targetInfo.targetType ?? initTargetInfo.targetType
                        const targetIdLocal = resultData.targetInfo.targetId ?? initTargetInfo.targetId
                        const sugotokuLocal = resultData.targetInfo.sugotoku ?? initTargetInfo.sugotoku
                        const ageLocal = resultData.targetInfo.age ?? initTargetInfo.age
                        const genderLocal = resultData.targetInfo.gender ?? initTargetInfo.gender
                        const prefectureLocal = resultData.targetInfo.prefecture ?? initTargetInfo.prefecture
                        let prefectureLocalArray = []
                        for (let i = 0; i < checkedPref.length; i++) {
                            prefectureLocalArray.push(prefectureLocal.includes(i + 1))
                        }
                        const categoryLocal = resultData.targetInfo.category ?? initTargetInfo.category
                        const geopointIdLocal = resultData.targetInfo.geopointid ?? initTargetInfo.geopointid
                        let targetIdfForCustomLocal = targetType === TARGET_TYPE.CUSTOM ? targetIdLocal : initTargetInfo.targetIdfForCustom
                        let targetIdForRetageLocal = targetType === TARGET_TYPE.RETAGE ? targetIdLocal : initTargetInfo.targetIdForRetage

                        const adGroupTmp = {
                            ...resultData,
                            targetInfo: {
                                targetType: targetType,
                                targetId: targetIdLocal,
                                targetIdfForCustom: targetIdfForCustomLocal,
                                targetIdForRetage: targetIdForRetageLocal,
                                gender: genderLocal,
                                age: ageLocal,
                                prefecture: prefectureLocal,
                                sugotoku: sugotokuLocal,
                                category: categoryLocal,
                                geopointid: geopointIdLocal,
                            }
                        }

                        setAdGroup(adGroupTmp)
                        setCheckedPref(prefectureLocalArray)

                        const osTypeLocal = createOsTypeDisplay(resultData.osType)
                        setOsType(osTypeLocal)

                        const trackingItems = getTrackingArrayItems(response.data.result.trackingParam)
                        setTrackingItems(trackingItems)
                        trackingItemMaxNo.current = trackingItems.length

                        beforeEditRecord.current = {
                            data: cloneDeep(adGroupTmp),
                            prefecture: prefectureLocal
                        }

                    } else if (response.data.resultcode === RESULT_KBN.ERROR) {
                        setmsg({
                            type: "setMessage",
                            payload: {
                                ...msg,
                                open: true,
                                type: "error",
                                message: `${MSG.ERR_GET_ADGROUP}${response?.data?.message ?? BLANK}`
                            }
                        });
                    }
                })
                .catch((err) => {
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...msg,
                            open: true,
                            type: "error",
                            message: `${MSG.ERR_GET_ADGROUP}${err?.errmsg ?? BLANK}`
                        }
                    });
                })
        }

        const fetchAudience = async () => {
            const url = `${process.env.REACT_APP_API_ENDPOINT}${hera_audiences_path}/${trackerId}`
            await ApolloAxios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${apolloContex.accesstoken}`,
                }
            })
                .then((response) => {
                    if (response.data?.resultCode < RESULT_KBN.SUCCESS) {
                        setmsg({
                            type: "setMessage",
                            payload: {
                                ...msg,
                                open: true,
                                type: "error",
                                message: `${MSG.ERR_GET_AUDIENCE}${response?.data?.message ?? BLANK}`
                            }
                        });
                    } else {
                        setTmpAudiences(response.data.result)
                    }
                })
                .catch((err) => {
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...msg,
                            open: true,
                            type: "error",
                            message: `${MSG.ERR_GET_AUDIENCE}${err?.errmsg ?? BLANK}`
                        }
                    });
                })
        }

        const fetchDeletedAudiences = async () => {
            // トラッカーIDが無い場合
            if (!trackerId) return;
            const url = `${process.env.REACT_APP_API_ENDPOINT}${hera_account_path}/${apolloContex.current.accountId}/audiences/deleted`;
            await ApolloAxios.get(url).then(response => {
                if (response.status !== 200) {
                    return Promise.reject({
                        open: true,
                        type: getResultType(response.status === 400 ? -1 : -9),
                        errmsg: `${MSG.ERR_GET_AUDIENCE}${response?.data?.message ?? BLANK}`,
                    });
                }
                if(response.data?.result) setTmpDeletedAudiences(response.data.result);
            }).catch(err => {
                setmsg({
                    type: "setMessage",
                    payload: {
                        ...msg,
                        open: true,
                        type: "error",
                        message: `${MSG.ERR_GET_AUDIENCE}${err?.errmsg ?? BLANK}`
                    }
                });
            });
        }

        const fetchCustomInfo = async () => {
            const url = `${process.env.REACT_APP_API_ENDPOINT}${list_poseidon_availabletarget_path}${accountGrpId}/${accountId}`
            await ApolloAxios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${apolloContex.accesstoken}`,
                },
                timeout: 60000 * 2,
            })
                .then((response) => {
                    if (response.data?.resultCode < RESULT_KBN.SUCCESS) {
                        setmsg({
                            type: "setMessage",
                            payload: {
                                ...msg,
                                open: true,
                                type: "error",
                                message: `${MSG.ERR_GET_CUSTOM}${response?.data?.message ?? BLANK}`
                            }
                        });
                    } else {
                        let customSegments: Custom[] = response.data.result ?? [];
                        customSegments.sort((a, b) => b.id - a.id);
                        setPoseidonCustoms(customSegments)
                    }
                })
                .catch((err) => {
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...msg,
                            open: true,
                            type: "error",
                            message: `${MSG.ERR_GET_CUSTOM}${err?.errmsg ?? BLANK}`
                        }
                    });
                })
        }

        const fetchAffinity = async () => {
            const url = `${process.env.REACT_APP_API_ENDPOINT}${list_poseidon_availableaffinity_path}`

            await ApolloAxios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${apolloContex.accesstoken}`,
                }
            })
                .then((response) => {
                    if (response.data?.resultCode < RESULT_KBN.SUCCESS) {
                        setmsg({
                            type: "setMessage",
                            payload: {
                                ...msg,
                                open: true,
                                type: "error",
                                message: `${MSG.ERR_GET_AFINITY}${response?.data?.message ?? BLANK}`
                            }
                        });
                    } else {
                        setPoseidonAffinities(response.data.result ?? [])
                    }
                })
                .catch((err) => {
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...msg,
                            open: true,
                            type: "error",
                            message: `${MSG.ERR_GET_AFINITY}${err?.errmsg ?? BLANK}`
                        }
                    });
                })
        }

        //広告一覧取得
        const fetchMsAds = async () => {
            const url = `${process.env.REACT_APP_API_ENDPOINT}${get_ms_advertisements_path}/${platformaccountid}/${campaignId}/${adGroupId}`
            await ApolloAxios.get(
                url,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apolloContex.accesstoken}`,
                    }
                }
            ).then((response) => {
                if (response.data.resultcode === RESULT_KBN.SUCCESS) {
                    setAdTrackingParams(response.data.result)
                } else {
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...msg,
                            open: true,
                            type: "error",
                            message: `${MSG.ERR_GET_ADVERTISEMENT}${response?.data?.message ?? BLANK}`
                        }
                    });
                }
            }).catch(err => {
                setmsg({
                    type: "setMessage",
                    payload: {
                        ...msg,
                        open: true,
                        type: "error",
                        message: `${MSG.ERR_GET_ADVERTISEMENT}${err?.errmsg ?? BLANK}`
                    }
                });
                alert(err);
            });
        };

        const fetchGeosegment = async () => {
            const url = `${process.env.REACT_APP_API_ENDPOINT}${list_poseidon_availablegeosegments_path}${accountGrpId}/${accountId}`
            await ApolloAxios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${apolloContex.accesstoken}`,
                }
            })
                .then((response) => {
                    if (response.data?.resultCode < RESULT_KBN.SUCCESS) {
                        setmsg({
                            type: "setMessage",
                            payload: {
                                ...msg,
                                open: true,
                                type: "error",
                                message: `${MSG.ERR_GET_GEOSEGMENT}${response?.data?.message ?? BLANK}`
                            }
                        });
                    } else {
                        const newGeosegments: Geosegment[] = response.data.result ?? [];
                        newGeosegments.sort((a, b) => b.id - a.id);
                        setGeosegments(newGeosegments)
                    }
                })
                .catch((err) => {
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...msg,
                            open: true,
                            type: "error",
                            message: `${MSG.ERR_GET_GEOSEGMENT}${err?.errmsg ?? BLANK}`
                        }
                    });
                })
        }

        if (processType === AdGroupProcessType.create) {
            const fetchAll = async () => {
                setmsg({
                    type: "loading",
                    payload: {
                        ...msg,
                        loading: true
                    }
                })

                if (campaignId === 0) {
                    await Promise.all(
                        [fetchMsCampaignList(), fetchAudience(), fetchCustomInfo(), fetchAffinity(), fetchAccount(), fetchGeosegment()]
                    ).finally(() => {
                        setmsg({
                            type: "loading",
                            payload: {
                                ...msg,
                                loading: false
                            }
                        })
                        setProgress(false)
                    })
                } else {
                    await Promise.all(
                        [fetchMsCampaign(), fetchMsCampaignList(), fetchAudience(), fetchCustomInfo(), fetchAffinity(), fetchAccount(), fetchGeosegment()]
                    ).finally(() => {
                        setmsg({
                            type: "loading",
                            payload: {
                                ...msg,
                                loading: false
                            }
                        })
                        setProgress(false)
                    })

                }
            }
            fetchAll();

        } else if (processType === AdGroupProcessType.edit) {

            const fetchAll = async () => {
                setmsg({
                    type: "loading",
                    payload: {
                        ...msg,
                        loading: true
                    }
                })

                await Promise.all(
                    [fetchMsCampaign(), fetchMsCampaignList(), fetchMsAdGroup(), fetchAudience(), fetchDeletedAudiences(), fetchCustomInfo(), fetchAffinity(), fetchAccount(), fetchMsAds(), fetchGeosegment()]
                ).finally(() => {
                    setmsg({
                        type: "loading",
                        payload: {
                            ...msg,
                            loading: false
                        }
                    })
                    setProgress(false)
                })
            }
            fetchAll();
        }

    }, [])

    useEffect(() => {
        const list: Audience[] = [];
        tmpAudiences?.map((v: Audience) => {
            const data: Audience = {
                ...v,
                name: v.isActive ? v.name : `${v.name}（停止中）`
            }
            list.push(data)
        })
        if(adGroup.adGroupId === INIT_NUMBER) {
            if(list?.length > 0) setHeraAudiences(list);
            return;
        }
        const deletedList = tmpDeletedAudiences.filter((d) => d.ID === adGroup.targetInfo.targetId);
        if(deletedList?.length > 0) {
            const data = deletedList[0];
            if(data.name?.match(/（削除済み）$/) === null) {
                data.name = `${data.name}（削除済み）`;
            }
            const audience  = list.concat(data);
            setHeraAudiences(audience);
        }else {
            setHeraAudiences(list);
        }
    }, [tmpAudiences, tmpDeletedAudiences, adGroup.adGroupId]);

    useEffect(() => {
        if (adGroup.bidCtgry === BID_CTRY.Manual_CPM && adGroup.targetInfo.targetType === TARGET_TYPE.RETAGE) {
            setAdGroup(prev => ({
                ...prev,
                targetInfo: {...adGroup.targetInfo, targetType: TARGET_TYPE.NONE_TARGET}
            }))
        }
    }, [adGroup.bidCtgry])

    useEffect(() => {
        if (!(adGroup.campaignType === CAMPAIGN_TYPE.RTM && adGroup.targetInfo.targetType == TARGET_TYPE.GEOTARGET_DEMOGRA)) {
            setAdGroup(prev => ({
                ...prev,
                targetInfo: {
                    ...adGroup.targetInfo,
                    targetType: adGroup.campaignType === CAMPAIGN_TYPE.RTM ? TARGET_TYPE.GEOTARGET : TARGET_TYPE.NONE_TARGET
                }
            }))
        }
    }, [adGroup.campaignType])

    const targetInfo =
        adGroup.targetInfo.targetType === TARGET_TYPE.NONE_TARGET ?
            <></> :
            adGroup.targetInfo.targetType === TARGET_TYPE.DEMOGRA || adGroup.targetInfo.targetType === TARGET_TYPE.GEOTARGET_DEMOGRA ?
                <DemograInfo
                    adGroup={adGroup}
                    options_affinity={options_affinity}
                    setState={setAdGroup}
                    control={control}
                    prefInfo={{
                        checkedPref: checkedPref,
                        setCheckedPref: setCheckedPref,
                        prefRenderId: prefRenderId,
                        setPrefRenderId: setPrefRenderId,
                    }}
                    setValue={setValue}
                    errors={errors}
                    disabled={disableTargeting}
                    enableSugotoku={enableSugotoku}
                /> :
                adGroup.targetInfo.targetType === TARGET_TYPE.CUSTOM ?
                    <ApolloBasicSelect
                        id={"custom"}
                        label=""
                        options={options_custom}
                        value={adGroup.targetInfo.targetIdfForCustom}
                        control={control}
                        errors={errors}
                        rules={{
                            required: "必須入力項目です。",
                        }}
                        setState={(e: any) =>
                            setAdGroup(prev => ({
                                ...prev,
                                targetInfo: {
                                    ...adGroup.targetInfo,
                                    targetIdfForCustom: e
                                }
                            }))
                        }
                        setValue={(name: string, value: any) => setValue(name, value)}
                        disabled={disableTargeting}
                    /> :
                    adGroup.targetInfo.targetType === TARGET_TYPE.RETAGE ?
                        <ApolloBasicSelect
                            id={"retage"}
                            label=""
                            options={options_audience}
                            value={adGroup.targetInfo.targetIdForRetage}
                            control={control}
                            errors={errors}
                            rules={{
                                required: "必須入力項目です。",
                            }}
                            setValue={(name: string, value: any) => setValue(name, value)}
                            setState={(e: any) =>
                                setAdGroup(prev => ({
                                    ...prev,
                                    targetInfo: {
                                        ...adGroup.targetInfo,
                                        targetIdForRetage: e
                                    }
                                }))
                            }
                            disabled={disableTargeting}
                        /> : <></>

    const geoSegment =
        adGroup.campaignType === CAMPAIGN_TYPE.RTM ?
            <ApolloBasicSelect
                id={"geosegment"}
                label="ジオセグメント"
                options={options_geosegment}
                value={adGroup.targetInfo.targetId}
                control={control}
                errors={errors}
                rules={{
                    required: "必須入力項目です。",
                }}
                setValue={(name: string, value: any) => setValue(name, value)}
                setState={(e: any) => {
                    const geoPoints = geosegments.filter(value => value.id === e)[0].geoPoints
                    setAdGroup(prev => ({
                        ...prev,
                        targetInfo: {
                            ...adGroup.targetInfo,
                            targetId: e,
                            geopointid: geoPoints.map(v => String(v.geoPointId)),
                        }
                    }))
                }
                }
                disabled={disableTargeting}
            /> : <></>

    return (
        <React.Fragment>
            {processType === AdGroupProcessType.edit ?
                <Typography variant="h6">
                    広告グループ編集：{adGroup.adGroupName}
                </Typography> : <></>
            }
            <Backdrop className={classes.backdrop2} open={progress}>
                <Bars color="#00BFFF" height={80} width={80}/>
            </Backdrop>
            <form noValidate onSubmit={onSubmit}>
                <Card className={classes.root} square variant="outlined">
                    <CardContent>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Typography variant="subtitle1" gutterBottom component="div">
                                    {"メニュー"}
                                </Typography>
                                <TextField
                                    id="campaignName"
                                    label=""
                                    fullWidth
                                    value="メール広告"
                                    disabled={true}
                                />
                            </Grid>
                            {processType === AdGroupProcessType.create ?
                                <React.Fragment>
                                    <Grid item xs={12}>
                                        <ApolloBasicSelect
                                            id="campaignType"
                                            label="キャンペーン"
                                            options={options_select_ms_campaign_type}
                                            value={adGroup.campaignType}
                                            control={control}
                                            rules={{
                                                validate: (e: any) => {
                                                    return e || "必須入力項目です。";
                                                }
                                            }}
                                            errors={errors}
                                            setState={(e: any) => setAdGroup(prev => ({
                                                ...prev,
                                                campaignType: e,
                                                campaignId: 0,
                                                bidCtgry: 0,
                                                cpcLimit: 0,
                                            }))
                                            }
                                            setValue={(name: string, value: any) => setValue(name, value)}
                                            placeholder="キャンペーン種別を選択"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <ApolloBasicSelect
                                            id="campaignName"
                                            label=""
                                            options={options_campaignNames}
                                            value={adGroup.campaignId || 0}
                                            control={control}
                                            disabled={!adGroup.campaignType}
                                            rules={{
                                                validate: (e: any) => {
                                                    if (e === null || e === 0) {
                                                        return "必須入力項目です。"
                                                    }
                                                }
                                            }}
                                            errors={errors}
                                            setState={(e: any) => {
                                                const bidCtgry = campaignList.filter(elem => elem.id === e)[0].bidCtgry
                                                setAdGroup(prev => ({
                                                    ...prev,
                                                    campaignName: valueToLabel(e, options_campaignNames),
                                                    campaignId: e,
                                                    bidCtgry: bidCtgry,
                                                }))
                                            }
                                            }
                                            setValue={(name: string, value: any) => setValue(name, value)}
                                            placeholder="キャンペーン名を選択"
                                        />
                                    </Grid>
                                </React.Fragment>
                                :
                                <React.Fragment>
                                    <Grid item xs={12}>
                                        <Typography variant="subtitle1" gutterBottom component="div">
                                            {"キャンペーン"}
                                        </Typography>
                                        <TextField
                                            id="campaignName"
                                            label="キャンペーン種別"
                                            fullWidth
                                            value={valueToLabel(adGroup.campaignType, options_ms_campaign_type)}
                                            disabled={true}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            id="campaignName"
                                            label="キャンペーン名"
                                            fullWidth
                                            value={`${adGroup.campaignId}_${adGroup.campaignName}`}
                                            disabled={true}
                                        />
                                    </Grid>
                                </React.Fragment>
                            }
                        </Grid>
                        <Grid container spacing={3}>
                            {[
                                <Divider/>,
                                <ApolloBasicTextField
                                    id="adGroupName"
                                    label="広告グループ名"
                                    value={adGroup.adGroupName}
                                    error={errors.adGroupName}
                                    required={true}
                                    inputRef={register({
                                        required: "必須入力項目です",
                                        maxLength: {
                                            value: 255,
                                            message: "255文字以内で入力して下さい。"
                                        },
                                        validate: (e: string) => {
                                            const errorMessage = checkInvalidTabCharsForName(e)
                                            if(errorMessage) {
                                                return errorMessage
                                            }},
                                    })}
                                    setState={(e: any) => setAdGroup(prev => ({...prev, adGroupName: e}))}
                                />,
                                <ApolloBasicSelect
                                    id="adType"
                                    label="広告種別"
                                    options={options_ms_ad_type_jp}
                                    value={adGroup.adType}
                                    control={control}
                                    errors={errors}
                                    disabled={processType === AdGroupProcessType.edit}
                                    setState={(e: any) => setAdGroup(prev => ({...prev, adType: e}))}
                                />,
                                <ApolloBasicSelect
                                    id="billingType"
                                    label="課金種別"
                                    options={options_ms_bid_ctgry}
                                    value={adGroup.bidCtgry}
                                    control={control}
                                    errors={errors}
                                    disabled={true}
                                    setState={(e: any) => setAdGroup(prev => ({...prev, adType: e}))}
                                    placeholder="キャンペーン名未選択"
                                />,
                                <ApolloBasicTextField
                                    id="cpcLimit"
                                    label="入札単価"
                                    value={adGroup.cpcLimit || ""}
                                    error={errors.cpcLimit}
                                    required={true}
                                    type="text"
                                    inputRef={register({
                                        required: "必須入力項目です。",
                                        validate: (e: number) => {
                                            if(e < 1) {
                                                return "1以上を入力して下さい。"
                                            }
                                            if(e > 999999999999) {
                                                return "999999999999以内を入力して下さい。"
                                            }
                                        },
                                    })}
                                    setState={(e: any) => {
                                        const value = e === BLANK ? null : Number(e)
                                        setAdGroup(prev => ({...prev, cpcLimit: value}))
                                    }
                                    }
                                    unNegative={true}
                                />,
                                <ApolloBasicSelect
                                    id="status"
                                    label="ステータス"
                                    options={processType === AdGroupProcessType.create
                                        ? options_state_edit_ms.filter((value: any) => value.value !== ARCHIVE_VALUE_NO)
                                        : options_state_edit_ms}
                                    value={adGroup.adGroupStatus}
                                    control={control}
                                    errors={errors}
                                    setState={(e: any) => setAdGroup(prev => ({...prev, adGroupStatus: e}))}
                                />,
                                <Grid container spacing={1}>
                                    <Grid container item xs={12}>
                                        <Typography variant="subtitle1" gutterBottom component="div">配信OS</Typography>
                                    </Grid>
                                    <Grid container item xs={12} style={{marginLeft: "1em"}}>
                                        <ApolloBasicCheck
                                            id={"osTypeIOS"}
                                            label={options_ms_os_type[2].label}
                                            checked={osType.ios}
                                            color={"primary"}
                                            disabled={adGroup.targetChangeable === 0}
                                            setState={(e: boolean) => {
                                                if (!osType.android && !e) return;
                                                setOsType({
                                                    ...osType,
                                                    ios: e,
                                                })
                                            }}
                                            labelPlacement={"end"}
                                        />
                                        <ApolloBasicCheck
                                            id={"osTypeAndroid"}
                                            label={options_ms_os_type[1].label}
                                            checked={osType.android}
                                            color={"primary"}
                                            disabled={adGroup.targetChangeable === 0}
                                            setState={(e: boolean) => {
                                                if (!osType.ios && !e) return;
                                                setOsType({
                                                    ...osType,
                                                    android: e,
                                                })
                                            }}
                                            labelPlacement={"end"}
                                        />
                                    </Grid>
                                </Grid>,
                                <Divider/>
                                ,
                                <ApolloBasicRadio
                                    id={""}
                                    label={"ターゲティング情報"}
                                    options={targetRadioOptions}
                                    value={adGroup.targetInfo.targetType}
                                    control={control}
                                    errors={errors}
                                    disabled={adGroup.targetChangeable === 0}
                                    setState={(e: any) => {
                                        setAdGroup(prev => ({
                                            ...prev,
                                            targetInfo: {...adGroup.targetInfo, targetType: Number(e)}
                                        }))
                                    }}/>,
                                geoSegment,
                                targetInfo,
                                <Divider/>,
                                <Grid container spacing={1}>
                                    <Grid container item xs={12}>
                                        <Typography variant="subtitle1" gutterBottom component="div">
                                            トラッキングパラメータ
                                        </Typography>
                                    </Grid>
                                    <Grid container item xs={12} style={{marginTop: "15px"}}>
                                        <Button type="button"
                                                variant="contained"
                                                color="primary"
                                                disabled={disableTrackingParam}
                                                onClick={onAddTrackingItem}>追加</Button>
                                    </Grid>
                                    <TrackingPointItem values={trackingItems}
                                                       setState={setTrackingItems}
                                                       register={register}
                                                       errors={errors}
                                                       clearErrors={clearErrors}
                                                       disabled={disableTrackingParam}
                                    />
                                    <Grid container item xs={12}>
                                        <p>※本広告グループに紐づくすべての広告のリンク先URLの末尾に上記のパラメータを共通で設定いたします。<br/>
                                            　尚、広告グループのパラメータを更新する場合、紐づく広告に設定されたパラメータが上書きされます。<br/>
                                            ※広告ごとに任意のパラメータを設定したい場合は、広告設定画面で設定くださいませ。</p>
                                    </Grid>
                                </Grid>
                            ].map((value) => {
                                return (
                                    <Grid item xs={12}>
                                        {value}
                                    </Grid>
                                )
                            })
                            }
                        </Grid>
                    </CardContent>
                    <CardActions className={classes.cardaction}>
                        <ApolloUserProfileAuth role={APOLLO_GROUP_OPERATOR} profile={APOLLO_SYSTEM_ADMIN}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                onClick={onSubmit}
                                className={classes.button}
                                disabled={formState.isSubmitting || processing.current}
                            >
                                {processType === AdGroupProcessType.create ? "作成" : "更新"}
                            </Button>
                        </ApolloUserProfileAuth>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={e => goBack(campaignId)}
                            className={classes.button}
                            disabled={formState.isSubmitting || processing.current}
                        >
                            戻る
                        </Button>
                    </CardActions>
                </Card>
                <Modal
                    className={adClasses.previewModalMs}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={openTrackingAlert}
                    onClose={trackingAlertCloseButtonClick}
                >
                    <Card className={classes.root} square variant="outlined">
                        <CardContent>
                            <Grid container spacing={1}>
                                <Grid container item xs={12}>
                                    広告に、トラッキングパラメータが設定されています。<br/>
                                    広告グループのパラメータを更新する場合、紐づく広告に設定されたパラメータが上書きされます。<br/>
                                    このまま更新を続けますか。<br/>
                                </Grid>
                                <Grid container item xs={3}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={trackingAlertContinueButtonClick}
                                        className={classes.button}
                                    >
                                        OK
                                    </Button>
                                </Grid>
                                <Grid container item xs={3}>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={trackingAlertCloseButtonClick}
                                        className={classes.button}
                                    >
                                        NO
                                    </Button>
                                </Grid>
                                <Grid container item xs={6}>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Modal>
            </form>
            <ApolloDialog open={openConfirmDialog} setOpen={setOpenConfirmDialog}>
                <ApolloConfirmNotActiveDialog
                    isExistsNotActiveAudience={isExistsNotActiveAudience.current}
                    isExistsDeletedAudience={isExistsDeletedAudience.current}
                    handleSave={handleSubmitExecute}
                    handleClose={handleCloseConfirm}
                />
            </ApolloDialog>
        </React.Fragment>
    );
};

const AreaPrefTable: React.FC<{
    checkedPref: boolean[],
    setCheckedPref: React.Dispatch<React.SetStateAction<boolean[]>>,
    prefRenderId: number,
    setPrefRenderId: React.Dispatch<React.SetStateAction<number>>
    disabled?: boolean,
}> = ({checkedPref, setCheckedPref, prefRenderId, setPrefRenderId, disabled}) => {
    const classes = apollo_useStyles();
    const [checkedArea, setCheckedArea] = useState([false, false, false, false, false, false, false,])

    const clickArea = (value: number, event: React.ChangeEvent<HTMLInputElement>) => {
        const bool = event.target.checked

        setCheckedArea(state => {
            state[value - 1] = bool
            return state
        })

        setCheckedPref(state => {
            const selectedOption = options_area_pref.filter(option => option.area.value === value)
            for (let pref of selectedOption[0].pref) {
                state[pref.value - 1] = bool
            }
            return state
        })

        setPrefRenderId(state => state + 1)
    }

    const clickPref = (value: number, event: React.ChangeEvent<HTMLInputElement>) => {
        const bool = event.target.checked

        setCheckedPref(state => {
            state[value - 1] = bool
            return state
        })

        setCheckedArea(state => {
            for (let option_area_pref of options_area_pref) {
                let areaBool = true
                for (let option_pref of option_area_pref.pref) {
                    if (!checkedPref[option_pref.value - 1]) {
                        areaBool = false
                        break
                    }
                }
                state[option_area_pref.area.value - 1] = areaBool
            }
            return state
        })

        setPrefRenderId(state => state + 1)
    }

    return (
        <TableContainer component={Paper}>
            <Table className={classes.table} size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>エリア</TableCell>
                        <TableCell>都道府県</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {options_area_pref.map((option_area_pref, index) => (
                        <TableRow key={index}>
                            <TableCell>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            id={`area${option_area_pref.area.value}`}
                                            name={`area${option_area_pref.area.value}`}
                                            color="primary"
                                            onChange={event => clickArea(option_area_pref.area.value, event)}
                                            key={prefRenderId}
                                            defaultChecked={
                                                checkedArea[option_area_pref.area.value - 1]
                                            }
                                            disabled={disabled}
                                        />
                                    }
                                    label={`${option_area_pref.area.label}`}
                                />
                            </TableCell>
                            <TableCell>
                                {option_area_pref.pref.map((option_pref, index) => (
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                id={`pref${option_pref.value}`}
                                                name={`pref${option_pref.value}`}
                                                color="primary"
                                                onChange={event => clickPref(option_pref.value, event)}
                                                key={prefRenderId}
                                                defaultChecked={
                                                    checkedPref[option_pref.value - 1]
                                                }
                                                disabled={disabled}
                                            />
                                        }
                                        label={`${option_pref.label}`}
                                        key={index}
                                    />
                                ))}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

const DemograInfo: React.FC<{
    adGroup: AdGroup,
    options_affinity: any,
    setState: any,
    control: any,
    prefInfo: {
        checkedPref: boolean[],
        setCheckedPref: any,
        prefRenderId: number,
        setPrefRenderId: any,
    },
    setValue: any,
    errors: any,
    disabled: boolean,
    enableSugotoku: boolean,
}> = ({adGroup, options_affinity, setState, control, prefInfo, setValue, errors, disabled, enableSugotoku}) => {
    const [openDemogra, setOpenDemogra] = useState(false);
    const {data: msg, setmsg} = React.useContext(ApolloMessage);
    return <React.Fragment>
        {enableSugotoku && adGroup.campaignType === CAMPAIGN_TYPE.MS ?
            <Grid item xs={12}>
                <ApolloBasicCheck
                    id={"sugotoku"}
                    label={"スゴ得情報を利用する"}
                    checked={adGroup.targetInfo.sugotoku[0] === 1}
                    labelPlacement={"end"}
                    setState={(checked: boolean) => {
                        setState({
                            ...adGroup,
                            targetInfo: {
                                ...adGroup.targetInfo,
                                sugotoku: [checked ? 1 : 0]
                            }
                        })
                    }}
                    disabled={disabled}
                />
            </Grid> : <></>
        }
        {adGroup.campaignType === CAMPAIGN_TYPE.RTM || adGroup.targetInfo.sugotoku[0] === 0 ?
            <React.Fragment>
                <Grid item xs={12}>
                    <Typography variant="subtitle1" gutterBottom component="div">
                        デモグラ情報
                    </Typography>
                    <IconButton aria-label="expand row" size="small" onClick={() => {
                        setOpenDemogra(state => !state)
                    }}>
                        {openDemogra ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
                    </IconButton>
                </Grid>
                <Grid item xs={12}>
                    <Collapse in={openDemogra} timeout="auto" unmountOnExit
                              style={{marginBottom: "5px"}}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Typography variant="subtitle1" gutterBottom component="div">
                                    {"性別"}
                                </Typography>
                                {
                                    ["男性", "女性", "不明"].map((elem, index) => {
                                        const no = index + 1
                                        return (
                                            <React.Fragment>
                                                <ApolloBasicCheck
                                                    id={`gender${index}`}
                                                    label={elem}
                                                    checked={adGroup.targetInfo.gender.includes(no)}
                                                    labelPlacement={"end"}
                                                    setState={(checked: boolean) => {
                                                        let genderArray: number[] = []
                                                        checked ? genderArray = [...adGroup.targetInfo.gender, no] : genderArray = adGroup.targetInfo.gender.filter((elem: number) => elem !== no)
                                                        setState({
                                                            ...adGroup,
                                                            targetInfo: {
                                                                ...adGroup.targetInfo,
                                                                gender: genderArray
                                                            }
                                                        })
                                                    }}
                                                    disabled={disabled}
                                                />
                                            </React.Fragment>
                                        )
                                    })
                                }
                            </Grid>
                            <Grid item xs={12}>
                                <Grid item xs={12}>
                                    <Typography variant="subtitle1" gutterBottom component="div">
                                        年齢
                                    </Typography>
                                    <Grid container alignItems="center">
                                        {
                                            ["ageMin", "ageMax"].map((elem, index) => {
                                                return (
                                                    <React.Fragment>
                                                        <Grid item xs={12} sm={2}>
                                                            <ApolloBasicSelect
                                                                id={elem}
                                                                label=""
                                                                options={options_age}
                                                                value={adGroup.targetInfo.age[index]}
                                                                control={control}
                                                                errors={errors}
                                                                isClearable={true}
                                                                setState={(e: any) => {
                                                                    let ageArray = [...adGroup.targetInfo.age];
                                                                    ageArray[index] = e;
                                                                    setState({
                                                                        ...adGroup,
                                                                        targetInfo: {
                                                                            ...adGroup.targetInfo,
                                                                            age: ageArray
                                                                        }
                                                                    })

                                                                }}
                                                                disabled={disabled}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} sm={1}>
                                                            <Typography variant="subtitle1" component="div"
                                                                        align="center">
                                                                {index === 0 ? "～" : ""}
                                                            </Typography>
                                                        </Grid>
                                                    </React.Fragment>

                                                )
                                            })
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="subtitle1" gutterBottom component="div">
                                    居住地
                                </Typography>
                                <AreaPrefTable
                                    checkedPref={prefInfo.checkedPref}
                                    setCheckedPref={prefInfo.setCheckedPref}
                                    prefRenderId={prefInfo.prefRenderId}
                                    setPrefRenderId={prefInfo.setPrefRenderId}
                                    disabled={disabled}
                                />
                            </Grid>

                        </Grid>
                    </Collapse>
                </Grid>
            </React.Fragment>
            : <></>
        }
        {adGroup.campaignType === CAMPAIGN_TYPE.MS && adGroup.targetInfo.sugotoku[0] === 0 ?
            <Grid item xs={12}>
                <ApolloBasicSelect
                    id="affinity"
                    label="アフィニティカテゴリ"
                    options={options_affinity}
                    value={adGroup.targetInfo.category}
                    control={control}
                    isMulti={true}
                    closeMenuOnSelect={false}
                    errors={errors}
                    rules={{}}
                    setState={(e: any) => {
                        if (e.length > AFFINITY_CATEGORY_MAX_MS) {
                            setmsg({
                                type: "setMessage",
                                payload: {
                                    ...msg,
                                    open: true,
                                    type: "warning",
                                    message: `アフィニティカテゴリは最大${AFFINITY_CATEGORY_MAX_MS}個まで設定可能です。`,
                                }
                            });
                            return;
                        }
                        const setVal = e ? e.map((target: any) => {
                            return target.value
                        }) : []
                        setState({
                            ...adGroup,
                            targetInfo: {
                                ...adGroup.targetInfo,
                                category: setVal
                            }
                        })

                    }}
                    disabled={disabled}
                    setValue={(name: string, value: any) => setValue(name, value)}
                />
            </Grid>
            : <></>
        }
    </React.Fragment>

}

const valueToLabel = function (value: any, options: Array<{ value: any; label: string }>): string {
    let option = options?.find(option => option.value === value)
    if (!option) {
        return ""
    } else {
        return option.label
    }
}

const createUserLog = (
    apolloContex: any,
    menu: string,
    category: string,
    actionType: string,
    displayName: string,
    beforeInfo: LogRecord | null,
    afterInfo: LogRecord,
    optionMaster: {
        status: any,
        campaignType: any,
        category: any,
        custom: any,
        retage: any,
        geosegment: any,
    },
    campaignId?: string,
    campaignName?: string,
    adGroupId?: string,
    adGroupName?: string,
) => {

    const transferedTargetInfoBefore = beforeInfo ? transferTargetInfo(beforeInfo.data.targetInfo, beforeInfo.prefecture) : null
    const transferedTargetInfoAfter = transferTargetInfo(afterInfo.data.targetInfo, afterInfo.prefecture)

    const beforeData = beforeInfo?.data ?? null
    const afterData = afterInfo?.data

    let items: ItemList[] = [
        createUserLogItemListFromOptionValue("キャンペーン種別", "campaignType", beforeData, afterData, optionMaster.campaignType),
        createUserLogItemListFromString("キャンペーン名", "campaignName", beforeData, afterData),
        createUserLogItemListFromString("広告グループ名", "adGroupName", beforeData, afterData),
        createUserLogItemListFromNumber("入札単価", "cpcLimit", beforeData, afterData),
        createUserLogItemListFromOptionValue("ステータス", "adGroupStatus", beforeData, afterData, optionMaster.status),
        createUserLogItemListFromRadioValues("配信OS", "osType", beforeData, afterData, options_ms_os_type),
        createUserLogItemListFromRadioValues("ターゲティング情報", "targetType", transferedTargetInfoBefore, transferedTargetInfoAfter, options_ms_ad_target)
    ]

    if (transferedTargetInfoAfter.targetType === 3) {
        if (adGroupId || transferedTargetInfoAfter.sugotoku[0] === 1) {
            items = items.concat([createUserLogItemListFromSugotokuMs("スゴ得情報", "sugotoku", transferedTargetInfoBefore, transferedTargetInfoAfter)])
        }
        items = items.concat([
            createUserLogItemListFromGenderMs("デモグラ情報_性別", "gender", transferedTargetInfoBefore, transferedTargetInfoAfter),
            createUserLogItemListFromAgeMs("デモグラ情報_年齢", "age", transferedTargetInfoBefore, transferedTargetInfoAfter),
            createUserLogItemListFromPrefectureMs("デモグラ情報_居住地", "prefecture", transferedTargetInfoBefore, transferedTargetInfoAfter),
            createUserLogItemListFromOptionValuesAfinitysMs("デモグラ情報_アフィニティ", "category", transferedTargetInfoBefore, transferedTargetInfoAfter, optionMaster.category)
        ])
    } else if (transferedTargetInfoAfter.targetType === 5) {
        items = items.concat([
            createUserLogItemListFromOptionValuesNormalListMs("カスタムセグメント", "targetId", transferedTargetInfoBefore, transferedTargetInfoAfter, optionMaster.custom),
        ])
    } else if (transferedTargetInfoAfter.targetType === 6) {
        items = items.concat([
            createUserLogItemListFromOptionValuesNormalListMs("オーディエンス", "targetId", transferedTargetInfoBefore, transferedTargetInfoAfter, optionMaster.retage),
        ])
    } else if (transferedTargetInfoAfter.targetType === 7) {
        items = items.concat([
            createUserLogItemListFromOptionValuesNormalListMs("ジオセグメント", "targetId", transferedTargetInfoBefore, transferedTargetInfoAfter, optionMaster.geosegment),
        ])
    } else if (transferedTargetInfoAfter.targetType === 17) {
        items = items.concat([
            createUserLogItemListFromGenderMs("デモグラ情報_性別", "gender", transferedTargetInfoBefore, transferedTargetInfoAfter),
            createUserLogItemListFromAgeMs("デモグラ情報_年齢", "age", transferedTargetInfoBefore, transferedTargetInfoAfter),
            createUserLogItemListFromPrefectureMs("デモグラ情報_居住地", "prefecture", transferedTargetInfoBefore, transferedTargetInfoAfter),
            createUserLogItemListFromOptionValuesNormalListMs("ジオセグメント", "targetId", transferedTargetInfoBefore, transferedTargetInfoAfter, optionMaster.geosegment),
        ])
    }
    items = items.concat([
        createUserLogItemListFromString("トラッキングパラメータ", "trackingParam", beforeData, afterData),
    ])

    const retObj = createLogDate(
        apolloContex,
        menu,
        category,
        actionType === AdGroupProcessType.create ? "作成" : "更新",
        displayName,
        items,
        campaignId,
        campaignName,
        adGroupId,
        adGroupName,
    )

    return retObj
}

export default AdGroupEditMs;
